export default "__VITE_ASSET__DC$T25GK__"